import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { ProblemSection } from '../components/sections/ProblemSection';
import { SolutionSection } from '../components/sections/SolutionSection';
import { ResultsSection } from '../components/sections/ResultsSection';
import { AudienceSection } from '../components/sections/AudienceSection';
import { BenefitsSection } from '../components/sections/BenefitsSection';
import { PricingSection } from '../components/sections/PricingSection';
import { HowItWorksSection } from '../components/sections/HowItWorksSection';
import { TestimonialSection } from '../components/sections/TestimonialSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FooterSection } from '../components/sections/FooterSection';
import { SocialProofPopup } from '../components/ui/SocialProofPopup';
export function LandingPage() {
  return <main className="min-h-screen bg-background text-gray-700 font-body selection:bg-primary/30 selection:text-white" data-id="element-394">
      <HeroSection data-id="element-395" />
      <ProblemSection data-id="element-396" />
      <SolutionSection data-id="element-397" />
      <AudienceSection data-id="element-398" />
      <ResultsSection data-id="element-399" />
      <BenefitsSection data-id="element-400" />
      <PricingSection data-id="element-401" />
      <HowItWorksSection data-id="element-402" />
      <TestimonialSection data-id="element-403" />
      <FAQSection data-id="element-404" />
      <FooterSection data-id="element-405" />
      <SocialProofPopup data-id="element-406" />
    </main>;
}